/**
 * Monta o cookie currentProfile a partir do afiliado logado no Comercial.
 * (No Hubstrom-Main esse cookie vem do SelectProfile; aqui o login não cria perfil.)
 */

export function buildProfileFromAffiliate(affiliate, uid) {
  if (!affiliate) return null;

  return {
    name: affiliate.name || "Comercial",
    office: "Comercial",
    profileId: uid,
    position: affiliate.position || "",
    photoUrl: affiliate.logoUrl || affiliate.photoUrl || "",
  };
}

export async function setCurrentProfileFromAffiliate(firebaseApp, cookie, uid) {
  if (!uid || !cookie) return null;

  const snapshot = await firebaseApp.database().ref(`affiliates/${uid}`).once("value");
  const affiliate = snapshot.val();

  if (!affiliate || affiliate.actived === false) {
    cookie.delete("currentProfile");
    return null;
  }

  const profile = buildProfileFromAffiliate(affiliate, uid);
  cookie.set("currentProfile", JSON.stringify(profile), { expires: "7D" });
  return profile;
}

export function clearCurrentProfile(cookie) {
  if (cookie) cookie.delete("currentProfile");
}
